import { useDispatch } from 'react-redux';
import EditDialog from '../Common/EditDialog';
import useClientGroupUserForm from '../../hooks/useClientGroupUserForm';
import { removeUserFromGroup } from '../../redux/actions/clientGroups';

function RemoveUserFromGroup({ setRemoveUserFromGroup, id }) {
  const { userGroupFormSchema } = useClientGroupUserForm(id, false);

  const dispatch = useDispatch();

  const handleUpdate = (data: any) => {
    dispatch(removeUserFromGroup(data.UserId, id));
  };

  return (
    <EditDialog
      update={handleUpdate}
      onClose={() => setRemoveUserFromGroup(false)}
      formSchema={userGroupFormSchema}
    />
  );
}

export default RemoveUserFromGroup;
